export default __webpack_public_path__ + "1baf02ab1405e22bf55916f3016fa919.jpg";